import { render, staticRenderFns } from "./Wrapper.vue?vue&type=template&id=2645431e&scoped=true&"
import script from "./Wrapper.vue?vue&type=script&lang=ts&"
export * from "./Wrapper.vue?vue&type=script&lang=ts&"
import style0 from "./Wrapper.vue?vue&type=style&index=0&id=2645431e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2645431e",
  null
  
)

export default component.exports